import React from "react";
import { Link } from "react-router-dom";


const SubSubCategory1 = ({ data }) => {
  // Dummy data for categories with placeholder images
  const baseImageUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/";

  const categories = data.get_home_component_details.content.map(
    (item, index) => ({
      id: item.sub_sub_category_auto_id,
      name: item.sub_category_name,
      image: item.subcategory_image_app
        ? `${baseImageUrl}${item.subcategory_image_app}`
        : "https://via.placeholder.com/400", 
    })
  );

  const truncateNameMobile = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };

 

  return (
    <div
      className="p-3 "
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      {" "}
      {/* Padding on both sides */}
      <h3
        className={`text-${data.title_alignment} p-3  ${data.web_title_font}`}
        style={{
          color: data.web_title_color,
        }}
      >
        {data.title}
      </h3>
      {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
      <div className="justify-center hidden w-full grid-cols-2 gap-1 overflow-hidden lg:grid">
        {categories.slice(0, 2).map((category) => (
          <div key={category.id} className="flex justify-center w-full">
            <div className="relative flex items-center w-full p-2 text-center">
            <Link
                to="/subsubcatproductlist"
                state={{
                  subsubcategoryName: category.name,
                  sub_sub_cat_id: category.id,
                }}
                className="flex flex-col items-center w-full text-decoration-none"
              >
                {/* Fully Rounded Image */}
                <img
                  src={category.image}
                  alt={category.name}
                  className="object-cover w-full"
                  style={{ height: "600px" }}
                />
                <div
                  className={`text-black text-2xl font-bold uppercase text-center p-2 drop-shadow-lg  ${data.web_title_font}`}
                >
                  {category.name}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <div className="justify-center hidden w-full grid-cols-3 gap-1 overflow-hidden lg:grid">
        {categories.slice(2, 5).map((category) => (
          <div key={category.id} className="flex justify-center w-full">
            <div className="relative flex items-center w-full p-2 text-center">
            <Link
                to="/subsubcatproductlist"
                state={{
                  subsubcategoryName: category.name,
                  sub_sub_cat_id: category.id,
                }}
                className="flex flex-col items-center w-full text-decoration-none"
              >
                {/* Fully Rounded Image */}
                <img
                  src={category.image}
                  alt={category.name}
                  className="object-cover w-full"
                  style={{ height: "350px" }}
                />
                <div
                  className={`text-black text-2xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
                >
                  {category.name}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div className="grid justify-center grid-cols-1 gap-1 lg:hidden">
        {categories.slice(0, 2).map((category) => (
          <div key={category.id} className="relative text-center">
             <Link
              to="/subsubcatproductlist"
              state={{
                subsubcategoryName: category.name,
                sub_sub_cat_id: category.id,
              }}
              className="flex flex-col items-center no-underline"
            >
              {/* Fully Rounded Image */}
              <img
                src={category.image}
                alt={category.name}
                className="object-cover w-full"
                style={{ height: "350px" }}
              />
              <div
                className={`text-black text-xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
              >
                {truncateNameMobile(category.name)}
              </div>
            </Link>
          </div>
        ))}

        {categories.slice(2, 5).map((category) => (
          <div key={category.id} className="relative text-center">
        
               <Link
               to="/subsubcatproductlist"
                state={{
                  subsubcategoryName: category.name,
                  sub_sub_cat_id: category.id,
                }}
              className="flex flex-col items-center no-underline"
            >
              {/* Fully Rounded Image */}
              <img
                src={category.image}
                alt={category.name}
                className="object-cover w-full"
                style={{ height: "220px" }}
              />
              <div
                className={`text-black text-xl font-bold uppercase text-center p-2 drop-shadow-lg ${data.web_title_font}`}
              >
                {truncateNameMobile(category.name)}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubSubCategory1;
